import { RUNTIME_ENV } from '@bfe/by-env';
import queryString from 'query-string';

import { REGULATED_SITE_HOSTS } from './constants/compliance';
import {
  API2_HOST as _API2_HOST,
  DOMAIN as _DOMAIN,
  DOMAIN_TYPE as _DOMAIN_TYPE,
  TOKEN_COOKIE_KEY,
} from './dynamic-domain';

// import getSourceType from './dynamic-domain';

const BYBIT_LANG_KEY = window.BYBIT_LANG_KEY || 'BYBIT_LANG_KEY';

// const sourceType = getSourceType(window.location.hostname);
export const BAN_COUNTRY_CODES = ['CN', 'SG'];
export const BAN_COUNTRY_ERROR_CODES = [31018];
export const BAN_PHONE_ERROR_CODES = [31020];

export const WARN_COUNTRY_CODES = ['GB'];

export const BYBIT_GUID_KEY = '_by_l_g_d';

const LANGUAGES = (() => {
  const HKGLANGS = [
    {
      label: '繁體中文 (香港)',
      lang: 'ZH',
      value: 'zh-HK',
    },
    {
      label: 'English(Hong Kong)',
      lang: 'EN',
      value: 'en-HK',
    },
  ];

  const NLDLANGS = [
    {
      label: 'English (Netherlands)',
      lang: 'EN',
      value: 'en-NL',
    },
    {
      label: 'Dutch',
      lang: 'NL',
      value: 'nl-NL',
    },
  ];

  const TURLANGS = [
    {
      label: 'English(Turkey)',
      lang: 'EN',
      value: 'en-TR',
    },
    {
      label: 'Türkçe',
      lang: 'TR',
      value: 'tr-TUR',
    },
  ];

  const KAZLANGS = [
    {
      label: 'Қазақша (Қазақстан)',
      lang: 'KK',
      value: 'kk-KAZ',
    },
    {
      label: 'Русский (Казахстан)',
      lang: 'RU',
      value: 'ru-KAZ',
    },
    {
      label: 'English (Kazakhstan)',
      lang: 'EN',
      value: 'en-KAZ',
    },
  ];

  const EUELANGS = [
    { label: 'English (Europe)', lang: 'EN', value: 'en-EU' },
    { label: 'Polski', lang: 'PL', value: 'pl-POL' },
    { label: 'Românǎ', lang: 'RO', value: 'ro-ROU' },
    { label: 'Español (España)', lang: 'ES', value: 'es-ESP' },
    { label: 'Português (Portugal)', lang: 'PT', value: 'pt-PRT' },
  ];

  const DEFAULTLANGS = [
    {
      label: 'English',
      lang: 'EN',
      value: 'en',
    },
    {
      label: 'Bahasa Indonesia',
      lang: 'ID',
      value: 'id-ID',
    },
    {
      label: 'Español (Internacional)',
      lang: 'ES',
      value: 'es-ES',
    },
    // {
    //   label: 'Español (Latinoamérica)',
    //   lang: 'ES',
    //   value: 'es-419',
    // },
    {
      label: 'Español (México)',
      lang: 'ES',
      value: 'es-MX',
    },
    {
      label: 'Español (Argentina)',
      lang: 'ES',
      value: 'es-AR',
    },
    // {
    //   label: 'Filipino',
    //   lang: 'FIL',
    //   value: 'fil-PH',
    // },
    {
      label: 'қазақша',
      lang: 'KK',
      value: 'kk-KZ',
    },
    {
      label: 'Português (Brasil)',
      lang: 'BR',
      value: 'pt-BR',
    },
    {
      label: 'Português(Internacional)',
      lang: 'PT',
      value: 'pt-PT',
    },
    {
      label: 'Русский',
      lang: 'RU',
      value: 'ru-RU',
    },
    {
      label: 'Tiếng Việt',
      lang: 'VI',
      value: 'vi-VN',
    },
    {
      label: 'Türkçe',
      lang: 'TR',
      value: 'tr-TR',
    },
    {
      label: 'ไทย',
      lang: 'TH',
      value: 'th-TH',
    },
    {
      label: 'Українська',
      lang: 'UK',
      value: 'uk-UA',
    },
    {
      label: 'العربيه',
      lang: 'AR',
      value: 'ar-SA',
    },
    // {
    //   label: 'हिंदी',
    //   lang: 'HI',
    //   value: 'hi-IN',
    // },
    {
      label: '日本語',
      lang: 'JA',
      value: 'ja-JP',
    },
    {
      label: '简体中文 (马来西亚)',
      lang: 'ZH',
      value: 'zh-MY',
    },
    {
      label: '繁體中文',
      lang: 'ZH',
      value: 'zh-TW',
    },
  ];

  let langs = [];
  switch (REGULATED_SITE_HOSTS) {
    case 'HKG':
      langs = HKGLANGS;
      break;
    case 'NLD':
      langs = NLDLANGS;
      break;
    case 'TUR':
      langs = TURLANGS;
      break;
    case 'KAZ':
      langs = KAZLANGS;
      break;
    case 'EU':
      langs = EUELANGS;
      break;
    default:
      langs = DEFAULTLANGS;
  }

  return langs;
})();

export const supportLanguages = (
  window.BybitSupportedLanguage || LANGUAGES
).map((item: { value: string; label: string; lang: string }) => item.value);

export const SUPPORT_LANGUAGES = (
  window.BybitSupportedLanguage || LANGUAGES
).filter(
  //TODO: en-US -> en
  // (item: { value: string; label: string; lang: string }) =>
  //   !['es-419', 'nl-NL', 'en-US'].includes(item.value),
  (item: { value: string; label: string; lang: string }) =>
    !['es-419'].includes(item.value),
);

export const I18N_URL_REGEX = /^(?:\/([a-z]{2,3}-[A-Z]{2,3}))?(\/.*)?/;

export const BYBIT_TOKEN_COOKIE_KEY = TOKEN_COOKIE_KEY;

export const cookieDomain = import.meta.env.PROD
  ? window.location.hostname.replace(/^www|m|testnet/, '')
  : 'localhost';

export const API2_HOST = localStorage.getItem('testApiUrl') || _API2_HOST;

export const KEY_VERSION = ['bybit'].includes(_DOMAIN) ? 'v2' : 'v1';

export const DOMAIN_TYPE = _DOMAIN_TYPE;
export const DOMAIN = _DOMAIN;

export const NEW_APP_WHITE_LIST = [
  // QA
  'mmz10@snapmail.cc',
  'mmz76@snapmail.cc',
  '9068681231',
  '1164344966',
  '92770132',
  '9012345601',
  '7823456999',
  'liang145@snapmail.cc',
  'liang148@snapmail.cc',
  'liangliang.cao-od@lunarax.io',
  'liang132@snapmail.cc',
  'amanda.zhang@lunarax.io',
  'manmanzhang888@gmail.com',
  '9012358999',
  '9012358999Child1',
  'mmz10Child1',
  'MMZ10Child2',
  'Mmz74@snapmail.cc',
  'mmz88@snapmail.cc',

  // user-test-2:
  'hanks0092@lista.cc', // 交易团队 3699718
  'hanks0093@lista.cc', // 交易团队 3699720
  'hanks0094@lista.cc', // 交易团队 3699722
  'hanks0095@lista.cc', // 交易团队 3699724
  'hanks0096@lista.cc', // 交易团队 3699726
  'hanks0091@lista.cc', // 投资人   3699452

  // jack.yu
  'jackyu24@snapmail.cc',
  'jackyu18@snapmail.cc',

  // mzry.li
  'mzry.li@uuf.me',
  'mzry@uuf.me',
  'jack.yang@uuf.me',
  // 子账号uid
  '3699698',
  '3699631',
  '3699684',
  '3699764',
];

export const NO_HEADER_H5_PATH = ['/app/user/audit', '/app/user/audit/detail'];
export { BYBIT_LANG_KEY, LANGUAGES };

export const PUBLIC_KEY: any = {
  test: `MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEA1unOHX8oH5VoAuwSxju0
rJGz0OzfQoS/kYZsCJImWYvdsc+xo7DiqDWttwURyJBK6Du5zSejvAm6hBM95z3x
xWnl8zDyCNp9QkVnVbpJLBLC7IDsYcfjluqsWj9wi0cHp7XQqZaddTBqXJm5+rqo
2QGasE9aTRgRPpBWvq1Z17Twg8TWpejXBbK+gfxgj0bMdDxMENU9POzBBHWZl7eF
U0y1+rx4gxdReSR/3DUzVbfGkDYmaiUw2a3MTGOulfnDOxWVcj4xJlTBroO11OQd
KE501UGpSRMoST5MmYJPvhhgsOOnPpCVL80uhO5J9VMIacEkHai8d2NtjndzwPEl
mwIDAQAB`,
  testnet: `MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAzqWJC9iJQ836EusWUungoMCwOPKcwRTbSDlAL0eVHKes3fvWcm0vwlDBagUSKke3Wb/VAXBeCX6RMLQakhDCTLVjVGEGHAE5iuQghyFBrH6End94wDGrkzuO23VkEnlVsrDZnMwzPUJHiRQjCmWjkLxEt27a6bPWC5G31LwCz4FotoQ4C4a3rZ24lM75BK8lFJ4MqMv9TDl9TVPNSd8XOEmjRW6XA02lYnX494UaBmQwmOKSS19QL0pyn2MQncQ6zOhZ7D8U7nPmaA7gPJGXYLv9wCqqEh1SRAH5Sv4AwaZIn95iL/Hv2BisSfsUR8u9D8sTkPYa75jlQX4Wbils3QIDAQAB`,
  prod: `MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEA6MIsf4XSrrbbOknUrtG9lBkaDB77agL6UzEwB/fUJVD/XFUvhF7LHIoBpfiDcgwlpBIAYL19oHqQ5H+pXqfAI3274rwbtOQt4IhqFre0pFKzT7alA0vJ1y/kXonPIaI4rq3oSSZkNg85eWL5Bc7JcbIyy70UrD12Kpv5LddFAEyRZdnDN7DqfoDndnWjSjwafDHzNYLiACvbWy+lcklXijwEYIPxmUvShqgs6cQAM6hBWTr7QwpNwc48U623PMAIrO6m22+v25YwoByKUWON4QaWReLR9spw781D0myiP50S0fX+sq0O4I3o6lDwHss50oE5uFhQ6JsR3LOzr0ZSuwIDAQAB`,
};

export const getPublicKey = () => {
  console.log('RUNTIME_ENV', RUNTIME_ENV);
  return PUBLIC_KEY[RUNTIME_ENV] || PUBLIC_KEY['prod'];
};

export const isOAuthHeader = () => {
  const paths = ['/app/user/sub-account-login'];
  const path = window.location.pathname;
  const search = queryString.parse(window.location.search);
  const fromOauth = Array.isArray(search.from)
    ? search.from?.includes('oauth')
    : search.from === 'oauth';
  const isOAuth = paths.includes(path) && fromOauth;
  if (isOAuth) {
    document
      .querySelector('#__bybit_uniframe_header__')
      ?.setAttribute('style', 'display: none');
    document.querySelector('body')?.setAttribute('style', 'min-width: auto');
  }
  return isOAuth;
};
// 浏览器版本过低检测弹窗，过期时间的cookie key，utc0 + 1的时间过期，防止频率过高
export const EXPIRE_TIME_KEY = BYBIT_TOKEN_COOKIE_KEY?.replace(
  'b_t_c_k',
  'detection_time',
);

export const DEFAULT_CAPTCHA_CONFIG = {
  // 邮箱手机号登陆，/login接口
  '31002': {
    completelyUseMagpieCatcha: false,
    useDowngrade: true,
    guidTailList: [],
    // 之前子账号登陆支持的行为验证，没有极验的！！！
    oldCapchaList: ['recaptcha', 'qqcaptcha'],
  },
};
